import React, { useState } from "react";
import { Box, Button, Typography, TextField, Tab, Tabs, Grid, Chip } from "@mui/material";
import TaskCalendar from "../tasks/task-calendar";
import axios from "axios";
import { useSelector } from "react-redux";

const PocketMoneyRecord = () => {
  const user = useSelector((state) => state.auth.user);
  const [activeTab, setActiveTab] = useState(0);
  const [moneyGiven, setMoneyGiven] = useState("");
  const [moneyUsed, setMoneyUsed] = useState("");
  const [moneyOwed, setMoneyOwed] = useState("");
  const [balance, setBalance] = useState("");
  const [note, setNote] = useState("");
  const [purchase, setPurchase] = useState("");
  const [currentDate, setCurrentDate] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState(new Date());

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handlePrevMonth = () => {
    setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1));
  };

  const handleNextMonth = () => {
    setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1));
  };

  const handleDateClick = (date) => {
    if (date instanceof Date) {
      setSelectedDate(date); // Ensure it's a Date object
    } else {
      setSelectedDate(new Date(date)); // Fallback to create a Date object
    }
  };

  function getWeekOfMonth(dateString) {
    const date = new Date(dateString);
    const startOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
    const dayOfWeek = startOfMonth.getDay(); // Day of the week for the 1st of the month
    const adjustedDate = date.getDate() + dayOfWeek;
    return Math.ceil(adjustedDate / 7); // Calculate week number
  }

  const handleSubmit = async () => {
    const requestData = {
      tab: activeTab === 0 ? "Money Provided" : activeTab === 1 ? "Money Spent" : "Money Through To",
      moneyGiven: activeTab === 0 ? moneyGiven : undefined,
      moneyUsed: activeTab === 1 ? moneyUsed : undefined,
      purchaseDetails: activeTab === 1 ? purchase : undefined,
      moneyOwed: activeTab === 2 ? moneyOwed : undefined,
      balance: activeTab === 2 ? undefined : balance,
      note,
      date: selectedDate.toISOString().split("T")[0],
      completed_by: user.username,
    };

    try {
      await axios.post("/api/pocketMoney/records", requestData);

      // Reset form fields
      setMoneyGiven("");
      setMoneyUsed("");
      setBalance("");
      setMoneyOwed("");
      setNote("");
    } catch (error) {
      console.error("Error saving record:", error);
      alert("Failed to save the record. Please try again.");
    }
  };

  return (
    <Box sx={{ p: 4, m: 2 }}>
      <Chip
        variant='contained'
        sx={{ fontSize: "14px", backgroundColor: "#F2F6FF", color: "#1751D0" }}
        label='Weekly Tasks'
      />
      {/* Header */}
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
        <Box>
          <Typography sx={{ fontSize: "24px", color: "black", fontWeight: "bold" }}>Pocket Money Record</Typography>
          <Typography variant='subtitle2' sx={{ color: "#757575" }}>
            Date: {new Date().toLocaleDateString()} &nbsp; • &nbsp;{" "}
            <span style={{ color: "#1751D0" }}>{user.username}</span>
          </Typography>
        </Box>
        {/* Starting Balance and Allowance */}
        <Box>
          <Typography variant='subtitle2' sx={{ color: "#757575" }}>
            Starting Balance: <span style={{ color: "#1751D0" }}>${65}</span>
          </Typography>
          <Typography variant='subtitle2' sx={{ color: "#757575" }}>
            Pocket Money Allowance: <span style={{ color: "#1751D0" }}>${125}</span>
          </Typography>
        </Box>
      </Box>
      <Grid container spacing={3}>
        <Grid item xs={12} lg={7}>
          {/* Week and Date Display */}
          <Typography variant='subtitle2' sx={{ color: "#757575", mb: 1 }}>
            <span style={{ fontSize: "20px", color: "#1751D0" }}>Week {getWeekOfMonth(selectedDate)}</span> &nbsp;
            &nbsp;{" "}
            <span style={{ color: "#1751D0" }}>
              {selectedDate.toLocaleDateString("en-US", {
                weekday: "long",
                month: "long",
                day: "numeric",
                year: "numeric",
              })}
            </span>
          </Typography>

          {/* Tab Navigation */}
          <Tabs value={activeTab} onChange={handleTabChange} sx={{ mb: 2 }}>
            <Tab label='Money Provided' sx={{ textTransform: "none" }} />
            <Tab label='Money Spent' sx={{ textTransform: "none" }} />
            <Tab label='Money Reparation' sx={{ textTransform: "none" }} />
          </Tabs>

          {/* Tab Content */}
          <Grid container spacing={2}>
            {activeTab === 0 && (
              <Grid item xs={12}>
                <Typography sx={{ fontSize: "14px", color: "black" }}>Money Given:</Typography>
                <TextField
                  fullWidth
                  type='number'
                  value={moneyGiven}
                  onChange={(e) => setMoneyGiven(e.target.value)}
                  sx={{ mb: 2 }}
                />
              </Grid>
            )}
            {activeTab === 1 && (
              <Grid item xs={12}>
                <Typography sx={{ fontSize: "14px", color: "black" }}>Details of Purchase Made :</Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  value={purchase}
                  onChange={(e) => setPurchase(e.target.value)}
                />
              </Grid>
            )}
            {activeTab === 1 && (
              <Grid item xs={12}>
                <Typography sx={{ fontSize: "14px", color: "black" }}>Money Spent:</Typography>
                <TextField
                  fullWidth
                  type='number'
                  value={moneyUsed}
                  onChange={(e) => setMoneyUsed(e.target.value)}
                  sx={{ mb: 2 }}
                />
              </Grid>
            )}

            {activeTab !== 2 && (
              <Grid item xs={12}>
                <Typography sx={{ fontSize: "14px", color: "black" }}>
                  {activeTab === 0 ? "Balance :" : "Balance Remaining :"}
                </Typography>
                <TextField
                  fullWidth
                  type='number'
                  value={balance}
                  onChange={(e) => setBalance(e.target.value)}
                  sx={{ mb: 2 }}
                />
              </Grid>
            )}

            {(activeTab === 0 || activeTab === 2) && (
              <Grid item xs={12}>
                <Typography sx={{ fontSize: "14px", color: "black" }}>
                  {activeTab === 0 ? "Comment :" : "Reason :"}
                </Typography>
                <TextField fullWidth multiline rows={3} value={note} onChange={(e) => setNote(e.target.value)} />
              </Grid>
            )}
            {activeTab === 2 && (
              <Grid item xs={12}>
                <Typography sx={{ fontSize: "14px", color: "black" }}>Money Owed through Reparation :</Typography>
                <TextField
                  fullWidth
                  type='number'
                  value={moneyOwed}
                  onChange={(e) => setMoneyOwed(e.target.value)}
                  sx={{ mb: 2 }}
                />
              </Grid>
            )}
          </Grid>
        </Grid>

        {/* Calendar Section */}
        <Grid item xs={12} lg={5}>
          <TaskCalendar
            currentDate={currentDate}
            selectedDates={[]}
            handlePrevMonth={handlePrevMonth}
            handleNextMonth={handleNextMonth}
            handleSelectedDatesUpdate={handleDateClick}
          />
        </Grid>
      </Grid>

      {/* Action Buttons */}
      <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3, gap: 2 }}>
        <Button variant='outlined'>Previous</Button>
        <Button variant='contained' onClick={handleSubmit}>
          Submit
        </Button>
      </Box>
    </Box>
  );
};

export default PocketMoneyRecord;
